// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f0568c79","453":"33c24c52"}[chunkId] + ".chunk.js";
};